(ns ui.components.read-only.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.languages :as languages]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]))

(defn- normalize-keyword
  [value]
  (cond
    (keyword? value) value
    (and (string? value)
         (string/starts-with? value ":"))
    (keyword (subs value 1))
    (string? value)
    (cu/str->keyword-if-string value)
    :else
    value))

(defn value-text
  [{:keys [data-type render-item]} value]
  (cond
    (fn? render-item)
    (render-item value)

    (= data-type :data.type/language)
    (or (languages/get-label value)
        (some-> value name))

    (= data-type :data.type/keyword)
    (some-> value
            normalize-keyword
            loc/tr)

    (= data-type :data.type/ref-single)
    (some->> (if (:db/id value)
               value
               (session/get-entity value))
             entity/display-string)

    :else
    (some-> value str)))

(defn multi-value-text
  [{:keys [values data-type render-item empty-text max-items]
    :or   {empty-text "-"
           max-items  5}}]
  (let [display-values (->> values
                            (keep (fn [value]
                                    (some->> value
                                             (value-text {:data-type   data-type
                                                          :render-item render-item})
                                             cu/empty-string)))
                            (sort-by cu/str-trim-lcase)
                            vec)
        value-count (count display-values)]
    (cond
      (zero? value-count)
      empty-text

      (> value-count max-items)
      (str (->> display-values
                (take 3)
                (string/join ", "))
           " and "
           (- value-count 3)
           " others")

      :else
      (string/join ", " display-values))))
